var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Interweave } from "interweave";
import { useHistory } from "react-router-dom";
import { AlertTriangle } from "react-feather";
import Button from "@gcp-artifact/compass/lib/components/updated/button";
import * as Styled from "./BillingOptionsStyles";
import { EInvoiceStatus, EInvoiceStatusFilter, } from "@/api/partners/partners.types";
import { Body } from "@/compass/components";
import { k } from "@/utilities/i18n";
import translate from "@/utilities/i18n/getTranslate";
import api from "@/api/admin";
import { useAcl } from "@/api/auth/useAcl";
import { MixpanelEvents } from "@/utilities/mixpanel/events";
var BillingOptionsBanner = function () {
    var history = useHistory();
    var _a = __read(React.useState(false), 2), hasPendingInvoice = _a[0], setHasPendingInvoice = _a[1];
    var partnerId = useAcl().partnerId;
    React.useEffect(function () {
        getPartnerInvoices();
    }, [partnerId]);
    var getPartnerInvoices = function () { return __awaiter(void 0, void 0, void 0, function () {
        var invoices, hasPendingInvoice_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!partnerId)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.partners.get.invoices({
                            partnerId: partnerId,
                            limit: 20,
                        })];
                case 2:
                    invoices = (_a.sent()).data;
                    hasPendingInvoice_1 = invoices === null || invoices === void 0 ? void 0 : invoices.some(function (invoice) {
                        return [EInvoiceStatus.UNPAID, EInvoiceStatus.ERROR].includes(invoice.paymentStatus);
                    });
                    setHasPendingInvoice(hasPendingInvoice_1);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    MixpanelEvents.errorEvent("Error fetching partner invoices", {
                        error: error_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var goToPendingInvoices = function () {
        history.push("/dashboard/billing/invoices?status=".concat([EInvoiceStatusFilter.UNPAID]));
    };
    return (React.createElement(React.Fragment, null, hasPendingInvoice && (React.createElement(Styled.WarningBanner, null,
        React.createElement(Styled.BannerContent, null,
            React.createElement(Styled.IconContainer, null,
                React.createElement(AlertTriangle, { size: 20, style: {
                        color: "var(--orange)",
                        filter: "drop-shadow(0 1px 2px rgba(255, 255, 255, 0.8))",
                    } })),
            React.createElement(Body, { color: "black", withoutMargins: true },
                React.createElement(Interweave, { content: translate(k.BILL_unpaidInvoiceMessage) }))),
        React.createElement(Button, { size: "small", margin: "0", variant: "secondary", onClick: goToPendingInvoices }, translate(k.BILL_unpaidInvoiceButton))))));
};
export default BillingOptionsBanner;
//# sourceMappingURL=data:application/json;base64,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